import { useClosePopup } from 'publisher/hooks/use-close-popup'
import useOptInSubmit from 'publisher/hooks/use-opt-in-submit-new'
import useBlog, { selectors as blogSelectors } from 'publisher/hooks/useBlog'
import React from 'react'
import { SendFormBasePublisherButton } from 'src/publisher/entities/send-form-base-publisher-button'
import { SendFormActionButtonEntityInterface } from 'src/shared/entities/button/send-form.action-button.schema'

const TEST_ID = 'blog-send-form-button'

export interface BlogSendFormButtonProps {
  entity: SendFormActionButtonEntityInterface
}

const BlogSendFormButton = ({ entity }: BlogSendFormButtonProps) => {
  const blogLayoutPageId = useBlog(blogSelectors.getBlogLayoutPageId)
  const closePopup = useClosePopup(entity, blogLayoutPageId)

  const [isLoading, errors, submit, isSuccess] = useOptInSubmit({
    optInButtonEntity: entity,
    closePopup,
  })

  return (
    <SendFormBasePublisherButton
      entityOrSubEntity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      testId={TEST_ID}
      isSuccess={isSuccess}
    />
  )
}

export default BlogSendFormButton
